/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo, useState } from "react";
import "./main.css";
import { myProjects } from "./myProjects";
import { AnimatePresence, motion } from "framer-motion";

const Main = () => {
  console.log("render")
  const [currentActive, setcurrentActive] = useState("all");
  const [arr, setArr] = useState(myProjects);
  /*New */
  const [sellectId, setSellectId] = useState(null)

  function handleId(id) {
    setSellectId(id)
  }
  /*New */

  const handleClick = (buttonCategory) => {
    setcurrentActive(buttonCategory);

    const newArr = myProjects.filter((item) => {
      const ZZZ = item.category.find((myItem) => {
        return myItem === buttonCategory;
      });

      return ZZZ === buttonCategory;
    });

    setArr(newArr);
  };


  return (

    <main className="flex" id="projects">
      <section className="flex  left-section">
        <button
          onClick={() => {
            setcurrentActive("all");
            setArr(myProjects);
          }}
          className={currentActive === "all" ? "active" : null}
        >
          all projects
        </button>

        <button
          onClick={() => {
            handleClick("css");
          }}
          className={currentActive === "css" ? "active" : null}
        >
          HTML & CSS
        </button>

        <button
          onClick={() => {
            handleClick("js");
          }}
          className={currentActive === "js" ? "active" : null}
        >
          JavaScript
        </button>
        <button
          onClick={() => {
            handleClick("react");
          }}
          className={currentActive === "react" ? "active" : null}
        >
          React
        </button>
      </section>

      <section className=" flex right-section">
        <AnimatePresence>
          {arr.map((item) => {

            return (
              <React.Fragment key={item.id}>
                {item.id === sellectId ?

                  <motion.div className="show-more" key={Date.now()}
                    layout
                    initial={{ transform: "scale(0.4)" }}
                    animate={{ transform: "scale(1)" }}
                  >
                    <div className="content" style={{ overflow: "hidden" }}>
                      <h1 className="title">{item.projectTitle}</h1>
                      <div className="box">
                        <div className="imgs flex">

                          <img style={{ transform: 'translateX(10px)' }} src={item.imgPath} alt="" />
                        </div>
                        <div className="links">
                          <a href={item.facebookVedio} target="_blank" rel="noreferrer">Video</a>
                          <a href={item.gitHubPath} target="_blank" rel="noreferrer">GitHub</a>
                        </div>
                      </div>
                      <h1 className="close" onClick={() => setSellectId(null)}>&times;</h1>
                    </div>

                  </motion.div>


                  :
                  <motion.article
                    layout
                    initial={{ transform: "scale(0.4)" }}
                    animate={{ transform: "scale(1)" }}
                    transition={{ type: "spring", damping: 8, stiffness: 50 }}
                    key={item.id}
                    className="card"
                    style={{ position: "relative" }}
                    onClick={() => handleId(item.id)}
                  >
                    <img width={266} src={item.imgPath} alt="" />
                    <div style={{ width: "266px" }} className="box">
                      <h1 className="title">{item.projectTitle}</h1>
                      <p className="sub-title">
                        Lorem ipsum dolor sit amet consectetur elit adipisicing . Ex
                        tempore dolor in, accusantium laudantium accusamus.
                      </p>
                      <div className="flex icons">
                        <div style={{ gap: "11px" }} className="flex">
                          <div className="icon-link"></div>
                          <a className="icon-github" href={item.gitHubPath} target="_blank" rel="noreferrer"></a>
                        </div>

                        <a className="link flex" href={item.facebookVedio} target="_blank" rel="noreferrer" >
                          Video On Facebook
                          <span
                            style={{ alignSelf: "end" }}
                            className="icon-arrow-right"
                          ></span>
                        </a>
                      </div>
                    </div>
                  </motion.article>
                }
              </React.Fragment>
            );
          })}
        </AnimatePresence>

      </section>
    </main>
  );
};

export default memo(Main);
